/*=========== POLLYFILLS ===========*/

// global polyfill
import 'core-js';

// Promise pollyfill
import 'promise-polyfill';

// Element.closest() polyfill
import 'element-closest-polyfill';

// string ends with polyfill
import '../polyfills/endsWith';

/*================================================*/

// import console logger
import 'core/utils/logger';

// import application bootstrap function
import { bootstrap } from 'core/bootstrap';

// App container is entry point of application
import { App } from 'ui/containers/__App__';

// bootstrap application when DOM tree is rendered
document.addEventListener( 'DOMContentLoaded', () => {

    // start bootstrap process
    log.debug( '[index.js] Bootstrap process started.' );

    // bootstrap application
    bootstrap( App, 'app' );

    // dispatch [message bus] bootstrap complete event
    log.info( '[index.js] Bootstrap process completed.' );

} );
